import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

// Export
import * as FileSaver from 'file-saver';
import { ExportService } from 'src/app/shared/services/export.service';

// Model
import { Table } from 'primeng/table';
import { GrowthStageCrudService } from 'src/app/shared/services/growth-stage-crud.service';
import { GrowthStage } from 'src/app/shared/interfaces/growth-stage';

@Component({
  selector: 'app-growth-stage',
  templateUrl: './growth-stage.component.html',
  styleUrls: ['./growth-stage.component.scss']
})
export class GrowthStageComponent implements OnInit {

  
  growthStages: GrowthStage[];
  growthStage: GrowthStage;
  selectedGrowthStages: GrowthStage[] = [];

  growthStageDialog: boolean = false;

  submitted: boolean = false;

  // column management
  cols: any[] = [];
  _selectedColumns: any[] = [];

  // export
  @ViewChild('dt', {static: true}) dt : any;
  exportColumns: any[] = [];

  // ui beadcrumb
  breadcrumbs: MenuItem[];
  homeBreadcrumb: MenuItem = {} as MenuItem;

  hideWhenNoPallet: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;

  separatorExp: string = "[,| ]";

  constructor(
    private growthStageService : GrowthStageCrudService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private exportService: ExportService
  ) { 
    // ui breadcrumbs
    this.breadcrumbs = [
      {label: 'Settings'},
      {label: 'GrowthStages'}
    ];

    this.growthStages = [];
    this.growthStage = { } as GrowthStage ;
  }

  ngOnInit(): void {

    this.isFilter = false;
    
    this.dataState();
    let s = this.growthStageService.getList(); 
    s.snapshotChanges().subscribe(data => {
      this.growthStages = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : GrowthStage = jsonItem as GrowthStage;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          this.growthStages.push(l);
        }
      })
    })

    // column management
    this.cols = [
      { field: 'name', header: 'Name' },
      { field: 'qrcode', header: 'QRCode' },
      { field: 'description', header: 'Description' },
      { field: 'tags', header: 'Tags' },
      { field: 'isEnabled', header: 'Enabled' },
      { field: 'actions', header: 'Actions' } 
    ];

    // column that we shoa at the beginning
    this._selectedColumns = this.cols;
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'description');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'isEnabled');

    // Exports
   // this.exportColumns = this.cols.map(col => ( {title: col.header, dataKey: col.field} ) );
   // For the PDF 
   this.exportColumns = this.cols.map(col => {
      if (col.field === 'position' || col.field === 'rank')  
        return {title: col.header, dataKey: 'position'};
      if (col.field !== 'actions')  
        return {title: col.header, dataKey: col.field};
      return {};
    } );
  }

  dataState() {     
    this.growthStageService.getList().valueChanges().subscribe(data => {
      this.preLoader = false;
      if(data.length <= 0){
        this.hideWhenNoPallet = false;
        this.noData = true;
      } else {
        this.hideWhenNoPallet = true;
        this.noData = false;
      }
    })
  }

  includesCol(val: string) : boolean{
    let c = this._selectedColumns.find(c => c.field === val);
    return c;
  }

  // Column management
  @Input() get selectedColumns(): any[] {
    // console.log('selected columns', this._selectedColumns);
    return this._selectedColumns;
  }
  set selectedColumns(val: any[]) {
    //restore original order
    // console.log('before selected columns', this._selectedColumns);
    // console.log('before cols', this._selectedColumns);
    this._selectedColumns = this.cols.filter(col => val.includes(col));
    // console.log('after selected columns', this._selectedColumns);
  }

  // Export management
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('l','pt');
            // @ts-ignore
            doc.autoTable(this.exportColumns, this.growthStages);
            doc.save('growthStages.pdf');
        })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.growthStages);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "growthStages");
    });
  }

  exportDTCSV() {
   // console.log('export csv');
    this.dt.exportCSV();
  }

  exportToCsv(): void {
    let exportCols : string[] = [];
    this.selectedColumns.forEach( sc => 
      { exportCols.push(sc.field);
        // console.log('SAVEC CSV COL F ',sc.field);
        // console.log('SAVEC CSV COL ',sc);
      });
      exportCols.push('position');
      // console.log('SAVEC CSV SELECTED LOCATIONS ', this.selectedGrowthStages);
      // console.log('SAVEC CSV LOCATIONS ', this.growthStages);
      // console.log('SAVEC CSV EXPORT COL ', exportCols);
      this.exportService.exportToCsv(this.selectedGrowthStages, 'growthStages', exportCols);
   // this.exportService.exportToCsv(this.growthStages, 'growthStages', ['$key', 'name', 'description', 'tags', 'isEnabled', 'actions']);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // CRUD management
  openNew() {
    this.growthStage = {} as GrowthStage;
    this.submitted = false;
    this.growthStageDialog = true;
  }

  deleteSelectedGrowthStages() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete the selected growthStages?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.growthStages = this.growthStages.filter(val => !this.selectedGrowthStages.includes(val));
            
            this.selectedGrowthStages.forEach( growthStage => this.growthStageService.delete(growthStage.$key));
            this.selectedGrowthStages = [];
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'GrowthStagess Deleted', life: 3000});
        }
    });
  }

  editGrowthStage(growthStage: GrowthStage) {
    this.growthStage = {...growthStage};
    this.growthStageDialog = true;
  }

  deleteGrowthStage(growthStage: GrowthStage) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete ' + growthStage.name + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.growthStages = this.growthStages.filter(val => val.$key !== growthStage.$key);
            this.growthStage = {} as GrowthStage;
            this.growthStageService.delete(growthStage.$key);
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'GrowthStage Deleted', life: 3000});
        }
    });
  }

  hideDialog() {
    this.growthStageDialog = false;
    this.submitted = false;
  }

  saveGrowthStage() {
    this.submitted = true;

    if ( this.growthStage.name.trim() ) {
      if (this.growthStage.$key) {
          this.growthStages[this.findIndexById(this.growthStage.$key)] = this.growthStage;                
          this.messageService.add({severity:'success', summary: 'Successful', detail: 'GrowthStage Updated', life: 3000});
          this.growthStageService.update(this.growthStage);
        } else {
          this.growthStage.position = this.growthStages.length;
          this.growthStageService.add(this.growthStage);
      }
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'GrowthStage Created', life: 3000});
      this.growthStages = [...this.growthStages];
    }

    this.growthStageDialog = false;
    this.growthStage = { } as GrowthStage;
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.growthStages.length; i++) {
        if (this.growthStages[i].$key === id) {
            index = i;
            break;
        }
    } 
    return index;
  }

  filter( dt : Table, event : {target: any} ) {
    dt.filterGlobal( (event.target as HTMLInputElement).value, 'contains')
  }

  completeGrowthStage(growthStage : GrowthStage) {
    //console.log("SAVE", growthStage);
    this.growthStageService.update(growthStage);
  }

  completePosition(growthStage : GrowthStage) {
   // console.log("SAVE", growthStage);
  //  this.growthStageService.updateGrowthStage(growthStage);


    if ( this.newPosition > -1 ) {
        growthStage.position = this.newPosition;
        growthStage = this.checkPositionLimits(growthStage);
        this.reorderElements(growthStage);
        //this.updateDB(growthStage);
        this.newPosition = -1;
        this.previousPosition = -1;
        return;
      }
  }


  @ViewChild('dt') tableElement: any; // already dt above
  isReordering : boolean = false;
  isAscReordering : boolean = false;
  isFilter : boolean = false;

  // Reorder
  reorder(event: any) {
    //console.log('Reorder event', event);
    // console.log('Before', this.growthStages);
    // const myClonedArray = [];
    // this.growthStages.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // console.log('Before2', myClonedArray);
    if (event.dragIndex === event.dropIndex ) {
      return;
    }
    const startIndex = this.isAscReordering? event.dragIndex : this.growthStages.length - 1 - event.dragIndex;
    const endIndex   = this.isAscReordering? event.dropIndex : this.growthStages.length - 1 - event.dropIndex;
    const growthStageToMove = this.growthStages[startIndex];
    
    
    // console.log('StartIndex', startIndex);
    // console.log('EndIndex', endIndex);

    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {
        this.growthStages[index] = this.growthStages[index+1];
        this.growthStages[index].position = index;
        this.growthStageService.update(this.growthStages[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.growthStages[index] = this.growthStages[index-1];
        this.growthStages[index].position = index;
        this.growthStageService.update(this.growthStages[index]);
      }
    } 
    this.growthStages[endIndex] = growthStageToMove;
    this.growthStages[endIndex].position = endIndex;
    this.growthStageService.update(this.growthStages[endIndex]);
  }

  // onFieldEdit(growthStage: Spray, fieldName: string): void {
  //   //console.log(this.growthStages);
  //   console.log("Edit Init Event Called");
  //   console.log('Field name :'+fieldName);
  //   console.log('Field value :' + growthStage[fieldName]);
  //   if (fieldName === 'position') {
  //     if ( this.newPosition ) {
  //       growthStage.position = this.newPosition;
  //       growthStage = this.checkPositionLimits(growthStage);
  //       this.reorderElements(growthStage);
  //       //this.updateDB(growthStage);
  //       this.newPosition = undefined;
  //       this.previousPosition = undefined;
  //       return;
  //     }
      
  //   } else {
  //     this.updateDB(growthStage);
  //   }
  // }


  ngAfterViewInit() {
    this.dt.onSort.subscribe((data: { field: string; order: number; }) => {
        if (data.field && data.field === "position") {
          this.isReordering = true;
          this.isAscReordering = (data.order == 1);
          // console.log("ASC", this.isAscReordering);
          // console.log("data.order", data.order);
        } else {
          this.isReordering = false;
        }
    });
    this.dt.onFilter.subscribe( (data: {
      filteredValue: {
        [x: string]: any; field: string; order: number; 
}; field: string; order: number; 
}) => {
      if (data && data.filteredValue) {
        this.isFilter = !(this.growthStages.length === data.filteredValue['length']);
      } else {
        this.isFilter = false;
      }
  });
  
}


  previousPosition : number = -1;
  newPosition : number = -1;

  modelChangeFn(event: number, growthStage: GrowthStage) {
    // console.log("event" +event);
    if (growthStage.position != null && growthStage.position > -1) {
      this.previousPosition = growthStage.position;
      this.newPosition = event;
    }
   
    // console.log("previous" +this.previousPosition);
    // console.log("new" +this.newPosition);
  }

  checkPositionLimits(growthStage: GrowthStage) {
    console.log('check ',growthStage.position + ' ' + this.growthStages.length);
    if (!growthStage.position) {
     // console.log('check 1');
      return this.growthStage;
    }
    if (growthStage.position < 0) {
      growthStage.position = 0;
      // console.log('check 2');
      return growthStage;
    }
    if (growthStage.position > this.growthStages.length) {
      growthStage.position = this.growthStages.length - 1;
    //  console.log('check 3', growthStage.position);
      return growthStage;
    }
   // console.log('check 4');
    return growthStage;
  }

  async reorderElements(growthStage: GrowthStage) {
    this.newPosition = this.newPosition  > this.growthStages.length ? this.growthStages.length - 1 : this.newPosition;
    this.newPosition = this.newPosition  < 0 ? 0 : this.newPosition;
    if (this.previousPosition === growthStage.position ) {
      return;
    }
    // console.log('Previous position: '+ this.previousPosition);
    // console.log('New position: '+ this.newPosition);
    const startIndex = this.previousPosition;
    const endIndex   = this.newPosition;
    const growthStageToMove = this.growthStages[startIndex];
   // console.log('Item to move: ', this.growthStages[startIndex]);
    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {

        console.log('LOC', this.growthStages);
        console.log('Item to +1: ', this.growthStages[index+1]);

        this.growthStages[index] = this.growthStages[index+1];
        this.growthStages[index].position = index;
        // console.log('Move: ', this.growthStages[index+1]);
        // console.log('Move pos: ', this.growthStages[index].position);
        //await this.updateDB(this.growthStages[index]);
        this.growthStageService.update(this.growthStages[index]);
     //   console.log('Update DB: ', this.growthStages[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.growthStages[index] = this.growthStages[index-1];
        this.growthStages[index].position = index;
        this.growthStageService.update(this.growthStages[index]);
      }
    } 
    this.growthStages[endIndex] = growthStageToMove;
    this.growthStages[endIndex].position = endIndex;
    this.previousPosition = -1;
    this.newPosition = -1;
    this.growthStageService.update(this.growthStages[endIndex]);
    
    // const myClonedArray = [];
    // this.growthStages.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // this.growthStages = myClonedArray;
   // this.getAllRecords();
  }
}
